import { SeItem, SeColumn } from './StyledElements.jsx'
import { formatDuration } from '../assets/assets_functions.js'
import { sessionColors } from '../assets/colors.js'

const StatItem = ({ stat, onClick, isGrey, isSelected, wA }) => {
  let temp_bg
  let temp_cl = sessionColors.itemText
  if (!isSelected && !isGrey) {
    temp_bg = sessionColors.itemNotSelectedNotGreyBg
  } else if (isSelected) {
    temp_bg = sessionColors.itemSelectedBg
    temp_cl = sessionColors.itemTextSelected
  } else temp_bg = sessionColors.itemNotSelectedGreyBg

  let i = 0
  return (
    <>
      <SeItem id={stat.year} onClick={onClick} bg={temp_bg} cl={temp_cl}>
        <SeColumn id={stat.year} w={wA[i]} align={'left'}>
          {stat.year}
        </SeColumn>
        <SeColumn id={stat.year} w={wA[++i]} align={'right'}>
          {stat.sessionsNb}
        </SeColumn>
        <SeColumn id={stat.year} w={wA[++i]} align={'right'}>
          {formatDuration(stat.sessionsDuration)}
        </SeColumn>
      </SeItem>
    </>
  )
}

export default StatItem
